<div>
  <app-hero-image-and-title [content]="(content?.fields.components)[0]"></app-hero-image-and-title>

  <div class="share-result__content">
    <app-test-result-profile
      *ngIf="testResult"
      [sharedTestResult]="true"
      [testResult]="testResult"
      [content]="(content?.fields.components)[1]"
    >
    </app-test-result-profile>

    <app-icon-title-ingress-and-cta [content]="(content?.fields.components)[2]"> </app-icon-title-ingress-and-cta>

    <div class="second-part">
      <app-title-and-ingress-banner
        [content]="(content?.fields.components)[3]"
        [backgroundColor]="'#ffffff'"
      ></app-title-and-ingress-banner>
      <app-how-compensate-works [content]="(content?.fields.components)[4]" [backgroundColor]="'#ffffff'">
      </app-how-compensate-works>
    </div>

    <app-sitra-banner [content]="(content?.fields.components)[5]"></app-sitra-banner>

    <app-invite [content]="(content?.fields.components)[6]" [smallerImage]="true"></app-invite>
  </div>
</div>
